var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8112 11.2794C24.5477 11.5249 26.1503 12.059 26.5053 10.944C26.8677 9.80304 25.3063 9.35382 24.5418 9.13387C24.4552 9.10895 24.3788 9.08695 24.3166 9.06725L23.632 11.2207C23.6834 11.2368 23.7436 11.2569 23.8112 11.2794Z",
    fill: "#F28214"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.742 14.7486C23.6242 15.041 25.5537 15.6807 25.9441 14.4519C26.3435 13.1956 24.468 12.6513 23.5529 12.3857C23.4507 12.3561 23.3603 12.3299 23.2866 12.3066L22.5317 14.6798C22.592 14.6989 22.6629 14.7224 22.742 14.7486Z",
    fill: "#F28214"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9801 12.6251C33.6348 18.1369 28.8867 22.3253 23.3749 21.9801C17.863 21.6349 13.6746 16.8868 14.0199 11.3749C14.3652 5.86307 19.1133 1.67468 24.6251 2.0199C30.137 2.36512 34.3254 7.11321 33.9801 12.6251ZM26.6299 8.44221C27.9884 9.00589 28.9592 9.78334 28.6767 11.0993C28.4711 12.0631 27.9003 12.4997 27.1708 12.6194C28.1255 13.1928 28.4009 14.185 28.0149 15.3396C27.3158 16.9922 25.8967 17.0462 24.0431 16.5755L23.4739 18.3634L22.3916 18.0212L22.953 16.2573C22.6724 16.1689 22.3858 16.0752 22.0907 15.9759L21.5269 17.7485L20.4458 17.4064L21.0146 15.6147L18.8349 14.9194L19.4597 13.6994C19.4597 13.6994 20.257 13.9642 20.2467 13.9479C20.5532 14.0441 20.7044 13.8506 20.7673 13.7199L22.3102 8.86701C22.3386 8.63512 22.2762 8.33679 21.8377 8.19782C21.8553 8.18702 21.0513 7.94999 21.0513 7.94999L21.4172 6.79833L23.6006 7.48447L24.1644 5.71313L25.2461 6.05526L24.694 7.79162C24.9855 7.8769 25.2782 7.96352 25.5625 8.05337L26.1108 6.32804L27.1931 6.67021L26.6299 8.44221Z",
    fill: "#F28214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinLight);
export default __webpack_public_path__ + "static/media/bitcoin-light.8e00e694547e002feb0db976b7002675.svg";
export { ForwardRef as ReactComponent };